export const SessionKey: string = 'LandfolioFramework';
export const LanguageIdKey: string = 'currentLanguageId';
export const LanguageLocaleKey: string = 'currentLanguageLocale';

export const AllSessionKeys: string[] = [ SessionKey, LanguageIdKey, LanguageLocaleKey ];